import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import HeaderBox from './HeaderBox';
import Nav from './Nav';
import UserBox from './UserBox';
import styles from './Sidebar.pcss';
const Sidebar = ()=>{
    useStyles(styles);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.wrapperSidebar,
        children: /*#__PURE__*/ _jsxs("aside", {
            className: styles.sidebar,
            children: [
                /*#__PURE__*/ _jsx(HeaderBox, {}),
                /*#__PURE__*/ _jsx(Nav, {}),
                /*#__PURE__*/ _jsx(UserBox, {})
            ]
        })
    });
};
export default Sidebar;
